import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const AuthWizardContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthWizardContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem('user') || localStorage.getItem('user');
    try {
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Failed to parse stored user:", error);
      return null;
    }
  });

  const navigate = useNavigate();

  const login = async (userData) => {
    console.log(userData);
    const requestBody = {
      process: '100019311',
      email: userData.email,
      password: userData.password,
    };


    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log("Login response:", data);

      if (data.responsecode === 0 && data.customer_id != 0) {
        const loggedInUser = {
          username: data.username,
          email: data.email,
          token: data.token,
          ppURL: data.image_url,
          customerName: data.customerName,
          introText: data.intro,
          title: data.TITLE,
          phone: data.PHONE,
          customerId: data.customer_id

          // Ekstra alanlar buraya eklenebilir
        }
        
        setUser(loggedInUser);
        sessionStorage.setItem('user', JSON.stringify(loggedInUser));
        localStorage.setItem('user', JSON.stringify(loggedInUser)); // localStorage'a da kaydet
        toast.success(`Logged in as ${data.username}`, { theme: 'colored' });
        navigate('/');
      }else if(data.responsecode == 0 && data.customer_id == 0){
        toast.error('Hesabiniz onay aşamasındadır. Sistem yöneticisiyle iletişime geçin.');
        }else{
        toast.error('Login failed. Please check your credentials.');
      }
    } catch (error) {
      console.error('Login failed', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          process: '100019312',
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok during logout');
      }

      const data = await response.json();
      console.log("Logout response:", data);

      if (data.responsecode === 1) {
        setUser(null);
        sessionStorage.removeItem('user');
        localStorage.removeItem('user'); // localStorage'dan da kaldır
        navigate('/authentication/split/login');
      } else {
        throw new Error('Logout failed');
      }
    } catch (error) {
      console.error('Logout failed', error);
      throw error;
    }
  };

  return (
    <AuthWizardContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthWizardContext.Provider>
  );
};
